import { motion, useReducedMotion } from 'framer-motion'
import FeatureCard, { FeatureItem } from './FeatureCard'

const FeatureGrid = ({ features }: { features: FeatureItem[] }) => {
  const reduceMotion = useReducedMotion()

  return (
    <div className='grid grid-cols-1 gap-4 lg:grid-cols-2'>
      {features.map((feature, index) => (
        <motion.div
          key={feature.title}
          initial={reduceMotion ? { opacity: 0 } : { opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: '0px' }}
          transition={{ duration: 0.4, delay: index * 0.06, ease: 'easeOut' }}
        >
          <FeatureCard {...feature} />
        </motion.div>
      ))}
    </div>
  )
}

export default FeatureGrid
